import React from "react";

const Kotlin_Exercises = () => {
  return (
    <div className="p-6">
      <h1 className="text-2xl font-bold mb-4">Kotlin Exercises</h1>
      <p>Content for Kotlin Exercises goes here.</p>
    </div>
  );
};

export default Kotlin_Exercises;
